import React, { useEffect, useState } from "react";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import Swal from "sweetalert2";

const ToggleSwitch = ({ item,record, index, handleUpdate, module }) => {
  const [, dispatch] = useDataLayerValue();
  const [isChecked, setIsChecked] = useState(item === 1);

const handleToggle = (e) => {
  const newChecked = e.target.checked;
  setIsChecked(newChecked);
  handleUpdate(newChecked); 
};

  return (
    <div style={{
        position:'absolute',
        top:'12px',
        bottom:'50%',
        right:'9rem'
    }}  key={index + record.id} className="custom-control custom-switch">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleToggle}
        className="custom-control-input"
        id={`customSwitch1${index}${record.id}`}
      />
      <label
        className="custom-control-label"
        htmlFor={`customSwitch1${index}${record.id}`}
      ></label>
    </div>
  );
};

export default ToggleSwitch;
